import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ExternallyManagedGuard } from '@lib/auth/guards/externally-managed.guard';
import { AxonRoutes } from '@lib/common/constants';

import { SnAccountSettingsContainer } from './containers';

const routes: Routes = [
  {
    path: 'settings',
    component: SnAccountSettingsContainer,
    data: {
      snRoute: {
        root: true,
      },
      snTitle: 'Account Settings',
      axonRoute: AxonRoutes.CURRENT_USER_PROFILE,
      allowNonAxonSso: true,
    },
    canActivate: [ExternallyManagedGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SnAccountRouting {}
